import { ApplicationInsights } from "@microsoft/applicationinsights-web"
import { useEffect } from "react"

const AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY =
  process.env.AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY

const AzureApplicationInsights = () => {
  useEffect(() => {
    // init application insights
    // Initialize Azure Application Insights
    if (
      window &&
      AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY &&
      !window.appInsights
    ) {
      window.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
        },
      })
      window.appInsights.loadAppInsights()
      window.appInsights.trackPageView()
    }
  }, [])

  return null
}

export default AzureApplicationInsights
